const About = {
    home: {
        name: "Daniela Shuman",
    },
    social: {
        instagram: "daniela.shuman",
        linkedin: "daniela-shuman"
    },

};

export default About;
